import { render, staticRenderFns } from "./articl.vue?vue&type=template&id=a188da34&scoped=true"
import script from "./articl.vue?vue&type=script&lang=js"
export * from "./articl.vue?vue&type=script&lang=js"
import style0 from "./articl.vue?vue&type=style&index=0&id=a188da34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a188da34",
  null
  
)

export default component.exports